<template>
  <div class="form-group has-helper" :class="{ 'has-error': showError }">
    <div :class="{ 'col-md-4': !stacked }">
      <label class="control-label"
        >Date of Birth:<span v-if="required">*</span></label
      >
      <p class="help-block" v-if="helper" v-text="helper"></p>
    </div>
    <div :class="{ 'col-md-8': !stacked }">
      <div class="input-group">
        <datepicker
          :name="name"
          :disabled="disabled"
          format="dd/MM/yyyy"
          :value="value"
          input-class="form-control"
          @selected="handleUpdate"
          :readonly="readonly"
        ></datepicker>
        <div class="input-group-append">
          <span class="input-group-text">{{ ageInYears }}</span>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
export default {
  props: {
    showError: Boolean,
    stacked: Boolean,
    value: [String, Date],
    required: Boolean,
    helper: String,
    unlimited: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      now: new Date()
    };
  },

  computed: {
    disabled() {
      if (this.unlimited) {
        return {
          from: this.now
        };
      }

      return {
        from: window.DateManager.subtractYears(this.now, 16)
      };
    },

    ageInYears() {
      if (this.value) {
        let difference = window.DateManager.differenceInYears(
          this.now,
          this.value
        );

        return `${difference} Years`;
      }

      return 'Please select a date';
    }
  },

  methods: {
    handleUpdate(newVal) {
      this.$emit('input', newVal);
    }
  }
};
</script>
